import axios, {
  AxiosResponse,
  AxiosError,
  InternalAxiosRequestConfig,
  AxiosRequestHeaders,
} from 'axios';
import {
  clearRememberMeData,
  loadRememberMeData,
  RememberMeData,
} from '../entities/auth/lib';

const API_URL = process.env.REACT_APP_BASE_URL;

const reloadCondition = (
  config: InternalAxiosRequestConfig | undefined
): boolean => {
  if (!config) return false;
  return !!(
    config.url?.endsWith("auth/token/") ||
    config.url?.endsWith('/logout') ||
    config.url?.endsWith('/password_reset')
  );
};

export const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export const okdeskClient = axios.create({
  baseURL: 'http://localhost:3001/api/',
});

apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    const rememberMeData: RememberMeData | null = loadRememberMeData();
    if (rememberMeData) {
      config.headers = {
        ...config.headers,
        Authorization: `Token ${rememberMeData.token}`,
      } as AxiosRequestHeaders;
    }

    return config;
  },
  (error: AxiosError) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    // (тут раньше стоял `console.log(error)` — снят, мусорил консоль
    // и затирал полезные ошибки в проде.)
    // 401 интерсептимся только тогда, когда у юзера БЫЛА сессия:
    // токен ушёл протухший, его надо выкинуть и перерисовать UI.
    //
    // Если юзер изначально без токена (например, открыл публичную
    // страницу — /registration/<uuid>, /password_reset/<uuid> и т.п.)
    // и бэк отдал 401 — это нормальный «доступ закрыт», UI сам
    // должен это обработать. Раньше тут шёл слепой
    // `window.location.reload()`, который превращался в бесконечный
    // цикл: страница загружается → fetch → 401 → reload → ... См.
    // баг от 18.05.2026 на /registration/<uuid>.
    const hadSession = !!loadRememberMeData();
    if (
      error.response?.status === 401 &&
      !reloadCondition(error.config) &&
      hadSession
    ) {
      clearRememberMeData();
      window.location.reload();
    }
    return Promise.reject(error);
  }
);
